// Shared store for syncing state between control window and presenter window
// Uses BroadcastChannel for live updates + localStorage for initial state hydration

const STORAGE_KEY = 'iri-conference-state';
const CHANNEL_NAME = 'iri-conference-channel';

let channel = null;
const getChannel = () => {
  if (!channel && typeof BroadcastChannel !== 'undefined') {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
};

export const publishState = (state) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    // ignore quota errors
  }
  const ch = getChannel();
  if (ch) ch.postMessage({ type: 'state', payload: state });
};

export const readInitialState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const subscribeToState = (callback) => {
  const ch = getChannel();
  if (!ch) return () => {};
  const handler = (event) => {
    if (event.data?.type === 'state') {
      callback(event.data.payload);
    }
  };
  ch.addEventListener('message', handler);
  return () => ch.removeEventListener('message', handler);
};

export const isPresenterRoute = () => {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('view') === 'presenter';
};
